import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Control } from 'react-hook-form';

export interface FormFieldProps {
  name: string;
  label: string;
  control: Control<any>;
  placeholder?: string;
  type?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;

}

export default function CustomFormField({
  name = "",
  label = "",
  control,
  placeholder = "",
  type = "text",
  required = false,
  disabled = false,
  className
}: FormFieldProps) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input
                disabled={disabled}
                required={required}
              placeholder={placeholder}
              type={type}
              className={cn(
                "h-10 w-full border border-gray-300 rounded-md shadow-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus:ring-black/50",
                placeholder && "placeholder:text-palette-text",
                className
              )}
              {...field}
            />
          </FormControl>
          <FormMessage className="text-red-500" />
        </FormItem>
      )}
    />
  );
}